import React, { Fragment } from "react";
import Footer from "../../footer";
import { Prompt, Redirect } from "react-router-dom";
import Question from "../formExam/Question.jsx";
import { connect } from "react-redux";
import { Howl } from "howler";
import Ball from "../../../assets/Ball.svg";
import SweetAlert from "react-bootstrap-sweetalert";
import axiosInstance from "../../../store/services/AxiosService";
import {
    deleteCaseActive,
    loadCaseSuccess,
    submitAnswer,
    saveAnswer,
    getStudentAnsweredCase,
} from "../../../store/actions/index";
import { withRouter } from "react-router-dom";
import "./ExamSingleQuestion.css";

class ExamSingleQuestion extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            // Question navigation
            currentQuestionIndex: 0,
            flatQuestions: [], // flattened array of { question, partIndex, questionIndex, partName, typeSoal, casePartId }

            // Alerts & submission
            alertSave: null,
            taskDone: false,
            alertSubmit: null,
            submitCases: false,
            countDown: 5,
            initCountDown: 5,

            // Focus detection (security)
            isFocus: true,
            isLocked: false,
            countNotFocus: 0,
            showFocusWarning: false,
            lastBlurTime: null,

            // UI state
            questions: [], // mini-map data: [{id, answered}]
            groupedQuestions: [], // grouped by part: [{partName, typeSoal, questions: [{id, answered, flatIndex}]}]
            isMinimapCollapsed: false,
            showPassword: false,
            passwordValue: "",

            // Auto-save
            autoSaveStatus: "idle", // 'idle' | 'saving' | 'saved'

            // Save flow
            isSaving: false,

            // Link Security Modal
            showLinkModal: false,
            linkUrl: "",
        };

        this.handleBlur = this.handleBlur.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
        this.handleOpenLink = this.handleOpenLink.bind(this);
        this.handleCloseLink = this.handleCloseLink.bind(this);

        // Auto-save
        this.autoSaveInterval = null;
        this.autoSaveInProgress = false;
        this.handleBeforeUnload = this.handleBeforeUnload.bind(this);
    }

    // ========== LIFECYCLE ==========

    async componentDidMount() {
        // Load case data if not already in Redux
        const fromLocalStorage =
            JSON.parse(localStorage.getItem("reduxState")) || {};
        const soalFromLocalStorage =
            JSON.parse(localStorage.getItem("dataSoal")) || {};
        if (fromLocalStorage.User.caseStudent.case_parts === undefined) {
            await this.fetchDataCase();
        } else if (soalFromLocalStorage === undefined) {
            await this.fetchDataCase();
        }

        // MathJax
        this.typesetMathJax();

        // Access check
        this.getAccess();

        // Focus detection listeners
        window.addEventListener("blur", this.handleBlur);
        window.addEventListener("focus", this.handleFocus);
        document.addEventListener(
            "visibilitychange",
            this.handleVisibilityChange
        );

        // Restore focus violation count and optimistic lock (per-exam)
        const caseKey = this.getCaseKey();
        const savedCount =
            parseInt(localStorage.getItem(caseKey)) || 0;
        this.setState({
            countNotFocus: savedCount,
            isLocked: savedCount >= 1 ? true : this.state.isLocked
        });

        // Build flattened question list and mini-map data
        this.buildFlatQuestions();

        // AUTO-SAVE: Start periodic auto-save every 60 seconds
        this.autoSaveInterval = setInterval(() => {
            this.autoSaveToServer();
        }, 60000);
        window.addEventListener("beforeunload", this.handleBeforeUnload);
    }

    componentDidUpdate(prevProps, prevState) {
        // Re-typeset MathJax when question changes
        if (
            prevState.currentQuestionIndex !== this.state.currentQuestionIndex
        ) {
            this.typesetMathJax();
        }

        // Update mini-map answered status
        const currentAnsweredCase = this.props.getStudentAnsweredCase();
        if (currentAnsweredCase && this.state.questions.length > 0) {
            const updatedQuestions = this.state.questions.map((question) => {
                if (currentAnsweredCase.includes(question.id)) {
                    return { ...question, answered: true };
                }
                return question;
            });

            const hasChanges = !this.deepEqual(
                this.state.questions,
                updatedQuestions
            );
            if (hasChanges) {
                this.setState({ questions: updatedQuestions });
            }
        }

        // Rebuild flat questions if case_parts changed
        if (
            prevProps.caseStudent.case_parts !==
            this.props.caseStudent.case_parts
        ) {
            this.buildFlatQuestions();
        }

        // Auto submit if timer runs out and at least one question is answered
        if (prevProps.timer.status === true && this.props.timer.status === false) {
            const hasAnswer = this.state.questions.some((q) => q.answered);
            if (hasAnswer && !this.state.submitCases) {
                this.submitExam(this.props.idStudent);
            }
        }
    }

    componentWillUnmount() {
        window.removeEventListener("blur", this.handleBlur);
        window.removeEventListener("focus", this.handleFocus);
        document.removeEventListener(
            "visibilitychange",
            this.handleVisibilityChange
        );

        // AUTO-SAVE: Clean up interval and beforeunload
        if (this.autoSaveInterval) {
            clearInterval(this.autoSaveInterval);
            this.autoSaveInterval = null;
        }
        window.removeEventListener("beforeunload", this.handleBeforeUnload);

        if (this.state.submitCases === true) {
            localStorage.removeItem("reduxState");
            localStorage.removeItem("dataSoal");
            localStorage.removeItem(this.getCaseKey());
            this.props.deleteCaseActive();
        }
    }

    // ========== DATA HELPERS ==========

    fetchDataCase = async () => {
        let res = await axiosInstance.get(
            `/cases/${this.props.currentCase.case_id}?schedule_id=${this.props.currentCase.schedule_id}&type_user=student&student_id=${this.props.idStudent}`
        );
        this.props.loadCaseSuccess(res.data);
        localStorage.setItem("dataSoal", JSON.stringify(res.data));
    };

    // AUTO-SAVE: Silently save answers to server every 60 seconds
    autoSaveToServer = () => {
        if (this.autoSaveInProgress || this.state.submitCases || this.state.isLocked) return;
        if (!this.props.caseStudent || !this.props.caseStudent.case_parts) return;

        this.autoSaveInProgress = true;
        const url = `/student_answers/create/student/${this.props.idStudent}?save=true`;
        const dataToPost = { studentAnswer: this.props.caseStudent };

        axiosInstance
            .post(url, dataToPost)
            .then(() => {
                console.log('[Auto-Save] Jawaban berhasil disimpan otomatis');
                this.autoSaveInProgress = false;
            })
            .catch((error) => {
                console.warn('[Auto-Save] Gagal menyimpan otomatis:', error.message);
                this.autoSaveInProgress = false;
            });
    };

    // AUTO-SAVE: Emergency save before tab/browser closes
    handleBeforeUnload(e) {
        if (this.state.submitCases) return;
        if (!this.props.caseStudent || !this.props.caseStudent.case_parts) return;

        const url = `/student_answers/create/student/${this.props.idStudent}?save=true`;
        const dataToPost = JSON.stringify({ studentAnswer: this.props.caseStudent });

        // Use sendBeacon for reliable delivery even when page is closing
        const baseURL = axiosInstance.defaults.baseURL || '';
        const fullUrl = baseURL + url;
        const blob = new Blob([dataToPost], { type: 'application/json' });
        navigator.sendBeacon(fullUrl, blob);
    }

    buildFlatQuestions() {
        if (!this.props.caseStudent.case_parts) return;

        let counter = 1;
        const flatQuestions = [];
        const minimapData = [];
        const groupedQuestions = [];

        this.props.caseStudent.case_parts.forEach(
            (casePart, partIndex) => {
                const groupQuestions = [];

                casePart.case_questions.forEach(
                    (question, questionIndex) => {
                        let answered = false;
                        if (casePart.type_name === "uraian" || casePart.type_name === "isian singkat") {
                            answered = question.answer && question.answer.value !== null && question.answer.value !== "";
                        } else {
                            answered = question.case_choices
                                ? question.case_choices.some(
                                    (choice) => choice.selected
                                )
                                : false;
                        }

                        const flatIndex = flatQuestions.length;

                        flatQuestions.push({
                            question,
                            partIndex,
                            questionIndex,
                            partName: casePart.name,
                            typeSoal: casePart.type_name,
                            casePartId: question.case_part_id,
                            globalIndex: counter,
                        });

                        const qData = {
                            id: counter,
                            answered,
                            flatIndex,
                        };

                        minimapData.push(qData);
                        groupQuestions.push(qData);

                        counter++;
                    }
                );

                groupedQuestions.push({
                    partName: casePart.name,
                    typeSoal: casePart.type_name,
                    partIndex,
                    questions: groupQuestions,
                });
            }
        );

        this.setState({
            flatQuestions,
            questions: minimapData,
            groupedQuestions,
        });
    }

    typesetMathJax() {
        if (window.MathJax) {
            try {
                window.MathJax.Hub.Queue([
                    "Typeset",
                    window.MathJax.Hub,
                    document.getElementsByTagName("body"),
                ]);
            } catch (e) {
                try {
                    window.MathJax.typesetPromise();
                } catch (e2) {
                    // MathJax not available
                }
            }
        }
    }

    deepEqual(arr1, arr2) {
        if (arr1.length !== arr2.length) return false;
        return arr1.every((obj, index) => {
            const obj2 = arr2[index];
            return Object.keys(obj).every(
                (key) => obj[key] === obj2[key]
            );
        });
    }

    // ========== FOCUS / SECURITY ==========

    getCaseKey = () => {
        const caseId = this.props.currentCase?.case_id || 'default';
        return `counterNotFocus_${caseId}`;
    };

    playAudio = () => {
        var sound = new Howl({
            src: [
                "https://soundbible.com/mp3/Air%20Horn-SoundBible.com-964603082.mp3",
            ],
            volume: 1,
        });
        setTimeout(() => {
            sound.play();
        }, 1000);
    };

    handleBlur(e) {
        if (this.state.isLocked || this.state.submitCases || this.state.isSaving) return;
        // Skip blur detection when a question link popup is active
        if (this._linkPopupActive) return;
        // Skip blur when clicking inside an iframe (e.g. embedded video)
        setTimeout(() => {
            if (document.activeElement && document.activeElement.tagName === "IFRAME") return;
            this._processBlur();
        }, 100);
    }

    _processBlur() {
        if (this.state.isLocked || this.state.submitCases || this.state.isSaving) return;

        const currentTime = Date.now();
        const lastBlur = this.state.lastBlurTime;
        if (lastBlur && currentTime - lastBlur < 1000) return;

        this.setState((prevState) => {
            const newCount = prevState.countNotFocus + 1;

            localStorage.setItem(this.getCaseKey(), newCount.toString());

            if (newCount >= 1) {
                // Lock immediately on first tab-out
                this.lockExamAccess();

                return {
                    lastBlurTime: currentTime,
                    countNotFocus: newCount,
                    isLocked: true,
                    isFocus: false,
                };
            }

            return {
                lastBlurTime: currentTime,
                countNotFocus: newCount,
            };
        });
    }

    handleFocus(e) {
        if (!this.state.isFocus && !this.state.isLocked) {
            this.setState({ isFocus: true });
        }
    }

    handleVisibilityChange() {
        if (document.hidden) {
            this.handleBlur();
        } else {
            this.handleFocus();
        }
    }

    lockExamAccess = () => {
        // Lock UI immediately (optimistic) — don't wait for API
        this.setState({ isFocus: false, isLocked: true });
        this.playAudio();

        // Persist lock to server (fire-and-forget)
        axiosInstance
            .post("/access/set", {
                case_id: this.props.currentCase.case_id,
                api_student_id: this.props.idStudent,
                student_name: this.props.studentName,
                schedule_id: this.props.caseStudent.schedules.id,
                is_generate: true,
                school_id: this.props.currentCase.school_id,
                is_locked: true,
            })
            .then((r) => {
                console.log("Lock persisted to server");
            })
            .catch((error) => {
                console.error(`Failed to persist lock => ${error.message}`);
                // UI stays locked regardless
            });
    };

    getAccess() {
        axiosInstance
            .post("/access/get", {
                case_id: this.props.currentCase.case_id,
                api_student_id: this.props.idStudent,
                student_name: this.props.studentName,
                schedule_id: this.props.caseStudent.schedules.id,
                school_id: this.props.currentCase.school_id,
            })
            .then((r) => {
                const lockedFromServer = r.data.is_locked == 1 || r.data.is_locked === true || r.data.is_locked === '1';
                this.setState({ isLocked: lockedFromServer ? true : this.state.isLocked });
            })
            .catch((error) => {
                console.error(`ERROR from Server => ${error.message}`);
            });
    }

    unlockAccess(password) {
        axiosInstance
            .post("/access/unlock", {
                case_id: this.props.currentCase.case_id,
                api_student_id: this.props.idStudent,
                student_name: this.props.studentName,
                schedule_id: this.props.caseStudent.schedules.id,
                school_id: this.props.currentCase.school_id,
                password: password,
            })
            .then((r) => {
                this.setState({
                    isLocked: false,
                    countNotFocus: 0,
                });
                localStorage.setItem("counterNotFocus", "0");
            })
            .catch((error) => {
                console.error(`ERROR from Server => ${error.message}`);
            });
    }

    convertToEmbedUrl(url) {
        // YouTube: convert watch/youtu.be/shorts URLs to embed format
        const ytRegex = /(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([\w-]+)/;
        const match = url.match(ytRegex);
        if (match) {
            return { embedUrl: `https://www.youtube.com/embed/${match[1]}`, canEmbed: true };
        }
        // Other sites generally block iframe embedding
        return { embedUrl: url, canEmbed: false };
    }

    handleOpenLink(url) {
        const { embedUrl, canEmbed } = this.convertToEmbedUrl(url);
        if (canEmbed) {
            // YouTube and other embeddable sites → show in iframe modal
            this.setState({
                showLinkModal: true,
                linkUrl: embedUrl,
            });
        } else {
            // Temporarily suppress blur detection for question link popups
            this._linkPopupActive = true;
            setTimeout(() => { this._linkPopupActive = false; }, 2000);

            // Sites that block iframes → open in a small popup window
            const width = 800;
            const height = 600;
            const left = (window.screen.width - width) / 2;
            const top = (window.screen.height - height) / 2;
            window.open(
                url,
                "exam_link_popup",
                `width=${width},height=${height},left=${left},top=${top},menubar=no,toolbar=no,location=no,status=no,scrollbars=yes,resizable=yes`
            );
        }
    }

    handleCloseLink() {
        this.setState({
            showLinkModal: false,
            linkUrl: "",
        });
    }

    // ========== NAVIGATION ==========

    goToQuestion = (index) => {
        if (
            index < 0 ||
            index >= this.state.flatQuestions.length
        )
            return;

        this.setState({ currentQuestionIndex: index });
    };

    goNext = () => {
        this.goToQuestion(this.state.currentQuestionIndex + 1);
    };

    goPrev = () => {
        this.goToQuestion(this.state.currentQuestionIndex - 1);
    };

    // ========== AUTO-SAVE ==========

    autoSaveCurrentAnswer = (callback) => {
        this.setState({ autoSaveStatus: "saving" });

        const url = `/student_answers/create/student/${this.props.idStudent}?save=true`;
        const dataToPost = { studentAnswer: this.props.caseStudent };

        axiosInstance
            .post(url, dataToPost)
            .then(() => {
                this.props.saveAnswer();
                this.setState({ autoSaveStatus: "saved" });
                setTimeout(() => {
                    this.setState({ autoSaveStatus: "idle" });
                }, 2000);
                if (callback) callback();
            })
            .catch((error) => {
                console.error(`Auto-save failed => ${error.message}`);
                this.setState({ autoSaveStatus: "idle" });
                // Still navigate even if save fails
                if (callback) callback();
            });
    };

    // ========== SAVE / SUBMIT ==========

    handleSave(e, status) {
        e.preventDefault();
        if (status === true) {
            // Directly save without confirmation dialog
            this.saveExam(this.props.idStudent);
        } else {
            const alertTimesUp = () => (
                <SweetAlert
                    warning
                    title="Kamu Tidak Dapat Simpan Sementara"
                    onConfirm={() => this.setState({ alertSave: null })}
                    onCancel={() => this.setState({ alertSave: null })}
                >
                    Serahkan Jawaban Untuk Menyimpan Jawaban Kamu !
                </SweetAlert>
            );
            this.setState({ alertSave: alertTimesUp() });
        }
    }

    handleDeleteImage(fileToDelete) {
        const url = "/files/delete";
        if (fileToDelete.length === 0) {
            fileToDelete.push("");
        }
        const dataToDel = { file_name: fileToDelete };
        axiosInstance
            .post(url, dataToDel)
            .then((r) => { })
            .catch((error) => {
                alert(`Proses delete gagal => ${error.message}`);
            });
    }

    deleteImageToSave(arrContent, arrAllFile) {
        let arrLama = [];
        if (arrAllFile !== null) {
            arrLama = arrAllFile;
        }
        arrContent.map((item) => {
            return (arrLama = arrLama.filter((i) => i !== item));
        });
        this.handleDeleteImage(arrLama);
    }

    saveExam(id_student) {
        this.setState({ alertSave: null });
        let arrImgContent = [];
        Object.values(this.props.caseStudent.case_parts).map(
            (part) => {
                Object.values(part.case_questions).map((question) => {
                    if (question.answer.file_attached !== null) {
                        arrImgContent.push(question.answer.file_attached);
                    }
                    return arrImgContent;
                });
                return arrImgContent;
            }
        );
        this.deleteImageToSave(arrImgContent, this.props.listImgAll);
        const url = `/student_answers/create/student/${id_student}?save=true`;
        const dataToPost = { studentAnswer: this.props.caseStudent };
        axiosInstance
            .post(url, dataToPost)
            .then(() => {
                this.props.saveAnswer();
                this.handleSuccessSave();
            })
            .catch((error) => {
                this.handleFailureSave(error);
            });
    }

    handleSuccessSave() {
        // Disable lock detection before redirecting
        this.setState({ isSaving: true, alertSave: null });
        window.removeEventListener("blur", this.handleBlur);
        window.removeEventListener("focus", this.handleFocus);
        document.removeEventListener("visibilitychange", this.handleVisibilityChange);

        // Redirect directly to student dashboard
        this.props.history.push("/");
    }

    handleFailureSave(errorMessage) {
        const alertFailure = () => (
            <SweetAlert
                warning
                title="Proses Gagal!"
                onConfirm={() => this.setState({ alertSave: null })}
                onCancel={() => this.setState({ alertSave: null })}
            >
                {errorMessage}
            </SweetAlert>
        );
        this.setState({ alertSave: alertFailure() });
    }

    handleSubmit(e) {
        e.preventDefault();
        this.setState({
            alertSubmit: "submit",
            countDown: this.state.initCountDown,
        });
    }

    submitExam(id_student) {
        this.setState({ alertSave: null, alertSubmit: null });
        let arrImgContent = [];
        Object.values(this.props.caseStudent.case_parts).map(
            (part) => {
                Object.values(part.case_questions).map((question) => {
                    if (question.answer.file_attached !== null) {
                        arrImgContent.push(question.answer.file_attached);
                    }
                    return arrImgContent;
                });
                return arrImgContent;
            }
        );
        this.deleteImageToSave(arrImgContent, this.props.listImgAll);
        const url = `/student_answers/create/student/${id_student}`;
        const dataToPost = { studentAnswer: this.props.caseStudent };
        axiosInstance
            .post(url, dataToPost)
            .then((response) => {
                // AUTO-SAVE: Stop auto-save after successful submit
                if (this.autoSaveInterval) {
                    clearInterval(this.autoSaveInterval);
                    this.autoSaveInterval = null;
                }
                this.props.submitAnswer();
                this.handleSuccessSubmit();
                this.setState({ submitCases: true });
            })
            .catch((error) => {
                this.handleFailureSubmit(error);
            });
    }

    handleSuccessSubmit() {
        const alertSuccess = () => (
            <SweetAlert
                success
                title="Berhasil !"
                onConfirm={() =>
                    this.setState({
                        taskDone: true,
                    })
                }
            >
                Jawabanmu berhasil disimpan !
            </SweetAlert>
        );
        this.setState({ alertSubmit: alertSuccess() });
    }

    handleFailureSubmit(errorMessage) {
        const alertFailure = () => (
            <SweetAlert
                warning
                title="Proses Gagal!"
                onConfirm={() =>
                    this.setState({ alertSubmit: null })
                }
                onCancel={() =>
                    this.setState({ alertSubmit: null })
                }
            >
                {errorMessage}
            </SweetAlert>
        );
        this.setState({ alertSubmit: alertFailure() });
    }

    // ========== RENDER ==========

    renderLockedState() {
        return (
            <div className="exam-locked-overlay">
                <SweetAlert
                    custom
                    showCloseButton={false}
                    closeOnClickOutside={false}
                    title="Akses dikunci!"
                    onConfirm={() => {
                        if (this.state.passwordValue.trim()) {
                            this.unlockAccess(this.state.passwordValue);
                            this.setState({
                                passwordValue: "",
                                showPassword: false,
                            });
                        } else {
                            alert("Masukkan password terlebih dahulu!");
                        }
                    }}
                    confirmBtnText="Unlock"
                    confirmBtnBsStyle="primary"
                >
                    <div
                        style={{
                            marginTop: "20px",
                            position: "relative",
                        }}
                    >
                        <input
                            id="password-input"
                            type={
                                this.state.showPassword
                                    ? "text"
                                    : "password"
                            }
                            className="form-control"
                            placeholder="Masukkan PASSWORD"
                            style={{
                                fontSize: "18px",
                                padding: "12px 45px 12px 15px",
                            }}
                            value={this.state.passwordValue}
                            onChange={(e) =>
                                this.setState({
                                    passwordValue: e.target.value,
                                })
                            }
                            onKeyPress={(e) => {
                                if (
                                    e.key === "Enter" &&
                                    this.state.passwordValue.trim()
                                ) {
                                    this.unlockAccess(
                                        this.state.passwordValue
                                    );
                                    this.setState({
                                        passwordValue: "",
                                        showPassword: false,
                                    });
                                }
                            }}
                            autoFocus
                        />
                        <i
                            className={
                                this.state.showPassword
                                    ? "mdi mdi-eye-off"
                                    : "mdi mdi-eye"
                            }
                            onClick={() =>
                                this.setState({
                                    showPassword: !this.state.showPassword,
                                })
                            }
                            style={{
                                position: "absolute",
                                right: "15px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                                fontSize: "20px",
                                color: "#666",
                            }}
                        />
                    </div>
                </SweetAlert>
            </div>
        );
    }

    getTypeSoalIcon(typeSoal) {
        const typeMap = {
            'pilihan ganda': { icon: '○', color: '#4361ee' },
            'pilihan ganda benar salah': { icon: '◐', color: '#7209b7' },
            'pilihan ganda kompleks': { icon: '◉', color: '#f72585' },
            'menjodohkan': { icon: '⇄', color: '#4cc9f0' },
            'isian singkat': { icon: '✎', color: '#f77f00' },
            'essay': { icon: '✍', color: '#06d6a0' },
        };
        return typeMap[typeSoal?.toLowerCase()] || { icon: '?', color: '#6c757d' };
    }

    renderMiniMap() {
        const { questions, groupedQuestions, currentQuestionIndex, isMinimapCollapsed } =
            this.state;
        const totalQuestions = questions.length;
        const answeredCount = questions.filter((q) => q.answered).length;
        const progressPercent =
            totalQuestions > 0
                ? Math.round((answeredCount / totalQuestions) * 100)
                : 0;

        return (
            <div className="exam-sidebar">
                <div className="exam-minimap-card">
                    <div className="exam-minimap-title">
                        <span>
                            Navigasi Soal ({answeredCount}/{totalQuestions})
                        </span>
                        <button
                            className="exam-minimap-toggle"
                            onClick={() =>
                                this.setState({
                                    isMinimapCollapsed:
                                        !isMinimapCollapsed,
                                })
                            }
                        >
                            {isMinimapCollapsed ? "▼" : "▲"}
                        </button>
                    </div>

                    {/* Progress bar */}
                    <div className="exam-progress-bar">
                        <div
                            className="exam-progress-fill"
                            style={{ width: `${progressPercent}%` }}
                        />
                    </div>

                    {!isMinimapCollapsed && (
                        <>
                            {/* Grouped by question type */}
                            <div className="exam-minimap-groups">
                                {groupedQuestions.map((group, gIndex) => {
                                    const typeInfo = this.getTypeSoalIcon(group.typeSoal);
                                    const groupAnswered = group.questions.filter(q => q.answered).length;
                                    return (
                                        <div className="exam-minimap-group" key={gIndex}>
                                            <div className="exam-minimap-group-header">
                                                <span
                                                    className="exam-minimap-type-badge"
                                                    style={{ backgroundColor: typeInfo.color }}
                                                >
                                                    {typeInfo.icon}
                                                </span>
                                                <span className="exam-minimap-group-label">
                                                    {group.typeSoal}
                                                </span>
                                                <span className="exam-minimap-group-count">
                                                    {groupAnswered}/{group.questions.length}
                                                </span>
                                            </div>
                                            <div className="exam-minimap-grid">
                                                {group.questions.map((q) => (
                                                    <div
                                                        key={q.id}
                                                        className={`exam-minimap-item ${q.answered ? "answered" : ""
                                                            } ${q.flatIndex === currentQuestionIndex
                                                                ? "active"
                                                                : ""
                                                            }`}
                                                        style={{
                                                            '--type-color': typeInfo.color,
                                                        }}
                                                        onClick={() =>
                                                            this.goToQuestion(q.flatIndex)
                                                        }
                                                    >
                                                        {q.id}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>

                            <div className="exam-minimap-legend">
                                <div className="exam-minimap-legend-item">
                                    <div className="exam-minimap-legend-dot answered" />
                                    <span>Dijawab</span>
                                </div>
                                <div className="exam-minimap-legend-item">
                                    <div className="exam-minimap-legend-dot unanswered" />
                                    <span>Belum</span>
                                </div>
                            </div>
                        </>
                    )}
                </div>

                {/* Action buttons below minimap */}
                <div className="exam-sidebar-actions">
                    {/* <button
                        disabled={this.props.isRemedial}
                        className="btn exam-btn-save exam-btn-full"
                        onClick={(e) =>
                            this.handleSave(
                                e,
                                this.props.timer.status
                            )
                        }
                    >
                        Simpan Sementara
                    </button> */}
                    {this.state.currentQuestionIndex === this.state.flatQuestions.length - 1 && (
                        <button
                            className="btn exam-btn-submit exam-btn-full"
                            onClick={(e) => this.handleSubmit(e)}
                        >
                            Serahkan Jawaban
                        </button>
                    )}
                </div>
            </div>
        );
    }

    renderCurrentQuestion() {
        const { currentQuestionIndex, flatQuestions } = this.state;
        if (flatQuestions.length === 0) return null;

        const current = flatQuestions[currentQuestionIndex];
        const totalQuestions = flatQuestions.length;

        return (
            <div className="exam-main-area">
                <div className="exam-question-card">
                    <div className="exam-question-header">
                        <div className="exam-question-counter">
                            Soal{" "}
                            <span>
                                {currentQuestionIndex + 1}
                            </span>{" "}
                            / {totalQuestions}
                        </div>
                        <div className="exam-part-label">
                            Bagian {current.partIndex + 1}:{" "}
                            {current.partName}
                        </div>
                        {this.state.autoSaveStatus !== "idle" && (
                            <div
                                className={`exam-autosave-indicator ${this.state.autoSaveStatus}`}
                            >
                                {this.state.autoSaveStatus === "saving"
                                    ? "⏳ Menyimpan..."
                                    : "✅ Tersimpan"}
                            </div>
                        )}
                    </div>

                    <div className="exam-question-body exam-question-transition" key={currentQuestionIndex}>
                        <Question
                            typeSoal={current.typeSoal}
                            itemQuestion={current.question}
                            indexQuestion={current.questionIndex}
                            casePartId={current.casePartId}
                            indexPart={current.partIndex}
                            onOpenLink={this.handleOpenLink}

                        />
                    </div>
                </div>

                {/* Navigation */}
                <div className="exam-navigation">
                    <button
                        className="exam-nav-btn prev"
                        onClick={() => this.goPrev()}
                        disabled={currentQuestionIndex === 0}
                    >
                        ← Sebelumnya
                    </button>

                    <button
                        className="exam-nav-btn next"
                        onClick={() => this.goNext()}
                        disabled={
                            currentQuestionIndex ===
                            totalQuestions - 1
                        }
                    >
                        Selanjutnya →
                    </button>
                </div>

                {/* Alert modals */}
                {this.state.alertSave}
                {this.state.alertSubmit === "submit" &&
                    !this.state.submitCases ? (
                    <SweetAlert
                        custom
                        showCancel
                        disabled={this.state.countDown !== 0}
                        showCloseButton
                        confirmBtnText="Ya"
                        cancelBtnText="Tidak"
                        confirmBtnBsStyle="primary"
                        cancelBtnBsStyle="light"
                        title="Serahkan Jawaban Kamu?"
                        onConfirm={() =>
                            this.submitExam(this.props.idStudent)
                        }
                        onCancel={() =>
                            this.setState({
                                alertSubmit: null,
                                countDown: this.state.initCountDown,
                            })
                        }
                        afterMount={() => {
                            let currCountDown = this.state.countDown;
                            var countDownInterval = setInterval(
                                () => {
                                    this.setState({
                                        countDown: currCountDown--,
                                    });
                                    if (
                                        this.state.countDown === 0 ||
                                        this.state.alertSubmit !==
                                        "submit"
                                    ) {
                                        clearInterval(
                                            countDownInterval
                                        );
                                    }
                                },
                                1000
                            );
                        }}
                    >
                        <div
                            style={{
                                marginTop: "1rem",
                                marginBottom: "1rem",
                                lineHeight: "1.5",
                            }}
                        >
                            Dengan Menyerahkan Jawaban, Maka Kamu Tidak
                            Bisa Mengerjakan Kembali
                        </div>
                        {this.state.countDown !== 0 ? (
                            <p
                                style={{
                                    color: "red",
                                    marginTop: "2rem",
                                    fontSize: "1",
                                    fontWeight: "400",
                                    lineHeight: "1.5",
                                }}
                            >
                                Tombol akan aktif dalam{" "}
                                {this.state.countDown} detik
                            </p>
                        ) : (
                            ""
                        )}
                    </SweetAlert>
                ) : (
                    this.state.alertSubmit
                )}
                {this.state.showLinkModal && this.renderLinkModal()}

            </div>
        );
    }

    renderLinkModal() {
        return (
            <div className="exam-link-modal-overlay">
                <div className="exam-link-modal-container">
                    <div className="exam-link-modal-header">
                        <h4 className="exam-link-modal-title">Lampiran Link</h4>
                        <button className="exam-link-modal-close" onClick={this.handleCloseLink}>×</button>
                    </div>
                    <div className="exam-link-modal-body">
                        <iframe
                            src={this.state.linkUrl}
                            title="Lampiran"
                            className="exam-link-modal-iframe"
                            sandbox="allow-scripts allow-same-origin allow-forms"
                        ></iframe>
                    </div>
                    <div className="exam-link-modal-footer">
                        <button className="btn btn-secondary" onClick={this.handleCloseLink}>Tutup</button>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (this.state.taskDone === true) {
            return <Redirect to="/" />;
        }

        if (this.state.isLocked) {
            return this.renderLockedState();
        }

        return (
            <Fragment>
                <Prompt
                    message={JSON.stringify({
                        confirmText: "Ya",
                        messageText: "Apakah kamu yakin keluar?",
                        cancelText: "Batal",
                    })}
                />
                <div className="main-panel">
                    <div
                        className="content-wrapper"
                        style={{ marginTop: "2rem" }}
                    >
                        {/* Focus warning banner */}
                        {this.state.showFocusWarning && (
                            <div className="exam-focus-warning">
                                ⚠️ PERINGATAN: Anda telah keluar dari
                                halaman ujian{" "}
                                {this.state.countNotFocus} kali. Satu
                                pelanggaran lagi akan mengunci ujian
                                Anda!
                            </div>
                        )}

                        {/* Violation count indicator */}
                        {this.state.countNotFocus > 0 && (
                            <span className="exam-violation-indicator">
                                ⚠️ Pelanggaran:{" "}
                                {this.state.countNotFocus}/1
                            </span>
                        )}

                        {this.props.caseStudent.case_parts ===
                            undefined ? (
                            <div className="d-flex justify-content-center">
                                <img
                                    src={Ball}
                                    className="img-fluid"
                                    alt=""
                                />
                            </div>
                        ) : (
                            <div>
                                {/* Header */}
                                <div className="page-header">
                                    <div className="page-title d-flex">
                                        <span className="page-title-icon bg-gradient-primary text-white mr-2">
                                            <i className="mdi mdi-lead-pencil"></i>
                                        </span>
                                        <h1
                                            style={{
                                                marginRight: "20px",
                                            }}
                                        >
                                            {
                                                this.props.caseStudent
                                                    .name
                                            }
                                        </h1>
                                        <label className="badge badge-gradient-danger align-self-center">
                                            {
                                                this.props.currentCase
                                                    .course_name
                                            }
                                        </label>
                                    </div>
                                </div>

                                {/* Two-column layout: minimap left, questions right */}
                                <div className="exam-single-question">
                                    {this.renderMiniMap()}
                                    {this.renderCurrentQuestion()}
                                </div>
                            </div>
                        )}
                    </div>
                    <Footer />
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        caseStudent: state.User.caseStudent,
        timer: state.User.timer,
        currentCase: state.User.currentCase,
        idStudent: state.User.dataStudent.student.api_student_id,
        listImgAll: state.User.caseStudent.listImg,
        isRemedial: state.User.currentCase.is_remedial,
        studentName: state.User.dataStudent.student.name,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadCaseSuccess: (list) => dispatch(loadCaseSuccess(list)),
        deleteCaseActive: () => dispatch(deleteCaseActive()),
        submitAnswer: () => dispatch(submitAnswer()),
        saveAnswer: () => dispatch(saveAnswer()),
        getStudentAnsweredCase: () =>
            dispatch(getStudentAnsweredCase()),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ExamSingleQuestion));
